<template>
	<div class="energy-left-box">
		<div class="left-box-left">
			<div class="left-box-left-1">
				<serverOverview></serverOverview>
			</div>
			<div class="left-box-left-2">
				<chargingTime></chargingTime>
			</div>
			<div class="left-box-left-3">
				<dischargeCapacity></dischargeCapacity>
			</div>

		</div>
		<div class="left-box-right">
			<div class="left-box-right-1">
				<operationInformation></operationInformation>
			</div>
			<div class="left-box-right-2">
				<time1></time1>
			</div>
			<div class="left-box-right-3">
				<totalElectricity></totalElectricity>
			</div>
		</div>
	</div>
</template>

<script>

	import serverOverview from "@/views/components/energyStorage/serverOverview.vue";
	import chargingTime from "@/views/components/energyStorage/chargingTime.vue";
	import dischargeCapacity from "@/views/components/energyStorage/dischargeCapacity.vue";
	import operationInformation from "@/views/components/energyStorage/operationInformation.vue";
	import time1 from "@/views/components/energyStorage/time1.vue";
	import totalElectricity from "@/views/components/energyStorage/totalElectricity.vue";
	export default {
		components: {
			serverOverview,
			chargingTime,
			dischargeCapacity,
			operationInformation,
			time1,
			totalElectricity

		},
		data() {
			return {

			};
		},

		mounted() {

		},
		deleted() {
			window.onresize = null;
		},
		methods: {

		},
		destroyed() {

		},
	};
</script>

<style scoped lang="scss">
	.energy-left-box {
		width: 1200px;
		height: 1470px;
		margin-top: 100px;
		display: flex;
		justify-content: space-between;
		padding-left: 30px;

		.left-box-left {
			width: 565px;
			height: 1470px;

			.left-box-left-1 {
				width: 565px;
				height: 354px;
			}

			.left-box-left-2 {
				margin-top: 50px;
				width: 565px;
				height: 426px;
				// background-color: salmon;
			}

			.left-box-left-3 {
				margin-top: 50px;
				width: 565px;
				height: 470px;
				// background-color: brown;
			}
		}

		.left-box-right {
			width: 565px;
			height: 1470px;

			.left-box-right-1 {
				width: 565px;
				height: 464px;
				// background-color: violet;
			}

			.left-box-right-2 {
				margin-top: 50px;
				width: 565px;
				height: 387px;
				// background-color: grey;
			}

			.left-box-right-3 {
				margin-top: 50px;
				width: 565px;
				height: 387px;
				// background-color: gainsboro;
			}
		}

	}
</style>